import React, { useEffect, useRef, useState } from "react";
import { Button, Input, message, Table, Tooltip } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HandleSearch from "../../utils/CommonSearchComponent";
import { useSelector } from "react-redux";
import { store } from "../../store";
import media from "../media";

import ExportPdf from "../../utils/exportPdf";

import ReactDOMServer from "react-dom/server";
import APICaller from "../../utils/APICaller";
import html2pdf from "html2pdf.js";
import { decryptData, paginationOptions } from "../Constants";
import moment from "moment";

const convertToDate = (dateStr) => {
  const [day, month, year] = dateStr && dateStr.split("-").map(Number);
  const currentYear = new Date().getFullYear();
  const currentYearLastTwoDigits = currentYear % 100;
  let fullYear =
    year < 100
      ? year <= currentYearLastTwoDigits
        ? currentYear - currentYearLastTwoDigits + year
        : currentYear - currentYearLastTwoDigits - 100 + year
      : year;
  return new Date(Date.UTC(fullYear, month - 1, day));
};

export default function ExpenseMultitasking(props) {
  const { Search } = Input;
  const [searchText, setSearchText] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const storeListRef = useRef([]);

  const {
    name,
    recordLimit = 50,
    status,
    showLoaderOnList,
    isFilterSelected,
    onFilteredData,
    searchFilterData,
    setSearchFilterData,
  } = props;

  const startRange =
    isFilterSelected &&
    isFilterSelected.startMonth &&
    isFilterSelected.startMonth;

  const endRange =
    isFilterSelected && isFilterSelected.endMonth && isFilterSelected.endMonth;

  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);
  const storeEmpID = storeUserInfo?.user?.empID;

  const [selectionType, setSelectionType] = useState("checkbox");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const storePagination = useSelector((state) => state.auth.pagination);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );

  const initialStoreTotalCount = useSelector((state) => state.auth.totalCount);
  const [storeTotalCount, setStoreTotalCount] = useState(
    initialStoreTotalCount
  );
  const [hasSelectedRows, setHasSelectedRows] = useState("");

  const [list, setList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false); // Add a state to track if data has been initially loaded
  const currentPath = location.pathname.replace("/", "");

  const searchIn =
    name === "dashboardPendingRequest"
      ? "pending-requests"
      : name === "dashboardListOfExpense"
      ? "list-of-expense"
      : currentPath;
  const [storeERList, setStoreERList] = useState([]);
  const [storeEListing, setStoreEListing] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const initialPagState = {
    current: 1,
    page: 1,
    pageSize: recordLimit,
  };
  const [pagination, setPagination] = useState(initialPagState);

  const refinedData =
    currentPath === "dashboard"
      ? storeEListing
        ? storeEListing
        : []
      : dataLoaded === true
      ? storeListRef.current
      : storeList;

  const getPendingRequestsList = async (source = "", pagination = "") => {
    currentPath !== "dashboard" &&
      setSearchFilterData &&
      setSearchFilterData("");
    setStoreTotalCount("");
    setShowLoader(showLoaderOnList === "yes");
    const inputElement = document.querySelector(".dashboardSearch span input");
    const hasSearchValue = inputElement ? inputElement.value : "";

    const callActionFrom = source ? source : "";
    const allStates = {
      showLoader,
      setShowLoader,
      pagination: pagination
        ? pagination
        : {
            current: 1,
            page: 1,
            pageSize: recordLimit,
          },
      setPagination,
      list,
      setList,
      status,
      filterValues: { startRange, endRange },
      searchKeyword: hasSearchValue || "",
    };

    try {
      await HandleSearch(
        storeRole,
        storeToken,
        storeLIUId,
        storeAccessTokenExpiresOn,
        searchIn,
        callActionFrom,
        allStates,
        ""
      );

      const authList = store.getState().auth.list;

      if (name === "dashboardPendingRequest") {
        setStoreERList(
          authList[process.env.REACT_APP_DASHBOARD_PR_SEARCH_IN + "_info"]
        );
      } else if (name === "dashboardListOfExpense") {
        setStoreEListing(
          authList[process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN + "_info"]
        );
      } else {
        const expenseInfo = authList[searchIn + "_info"];
        if (isFilterSelected === null) {
          if (hasSearchValue) {
            currentPath !== "dashboard" &&
              setSearchFilterData(
                status === "ALL" ||
                  status.includes(
                    process.env.REACT_APP_TAB_PAYMENT_PENDING_STATUS.toUpperCase()
                  ) ||
                  status.includes(
                    process.env.REACT_APP_MY_REQUESTS.toUpperCase()
                  )
                  ? expenseInfo
                  : expenseInfo &&
                      expenseInfo.filter((item) =>
                        status.includes(item.status.toUpperCase())
                      )
              );
          } else {
            setStoreList(
              status === "ALL" ||
                status.includes(
                  process.env.REACT_APP_TAB_PAYMENT_PENDING_STATUS.toUpperCase()
                ) ||
                status.includes(process.env.REACT_APP_MY_REQUESTS.toUpperCase())
                ? expenseInfo
                : expenseInfo &&
                    expenseInfo.filter((item) =>
                      status.includes(item.status.toUpperCase())
                    )
            );
          }
          // Call the callback function to pass filtered data
          if (onFilteredData) {
            onFilteredData(
              status === "ALL" ||
                status.includes(
                  process.env.REACT_APP_TAB_PAYMENT_PENDING_STATUS.toUpperCase()
                ) ||
                status.includes(process.env.REACT_APP_MY_REQUESTS.toUpperCase())
                ? expenseInfo
                : expenseInfo &&
                    expenseInfo.filter((item) =>
                      status.includes(item.status.toUpperCase())
                    )
            );
          }
        }
        if (startRange && endRange) {
          storeListRef.current = expenseInfo;
        }
      }
    } catch (error) {
      console.error("Error fetching expense requests list: ", error);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (!isFilterSelected) {
      setDataLoaded(false);
      getPendingRequestsList();
    } else {
      setDataLoaded(true);
      if (dataLoaded === true) {
        // Ensure startRange and endRange are available before proceeding
        if (startRange && endRange) {
          getPendingRequestsList("filtered", pagination);
        }
      }
    }
  }, [
    name,
    recordLimit,
    ...(searchIn === process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN
      ? status
      : ""),
    currentPath,
    isFilterSelected,
    dataLoaded,
  ]);

  const sAColumn = [
    {
      title: "Approvers",
      dataIndex: "approvers",
      render: (approvers) => (
        <div className="d-flex justify-content-center">
          {approvers &&
            approvers.map((approver, index) => (
              <Tooltip
                key={index}
                title={`${approver?.additional?.name.toUpperCase()}, ${
                  approver?.status ? approver?.status : "NOT SENT"
                }`}
                className={`approvers-tooltips ${
                  approver?.status
                    ? approver?.status?.toLowerCase()
                    : "yetToSent"
                }-tooltips`}
              >
                <span></span>
              </Tooltip>
            ))}
        </div>
      ),
    },
  ];

  const aAColumn = [
    {
      title: "Admin Action",
      dataIndex: "adminApprover",
      render: (text) => <span>{text}</span>,
    },
  ];
  let additionalSAColumn =
    name === "dashboardListOfExpense" ||
    searchIn === "list-of-expense" ||
    searchIn === "pending-requests"
      ? sAColumn
      : "";
  let additionalAAColumn =
    name === "dashboardListOfExpense" ||
    searchIn === "list-of-expense" ||
    searchIn === "pending-requests"
      ? aAColumn
      : "";

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setHasSelectedRows(selectedRows.map((row) => row.id));
    },
    // getCheckboxProps: (record) => ({
    //   disabled: record.name === "Disabled User",
    //   // Column configuration not to be checked
    //   name: record.name,
    // }),
  };

  const columns = [
    {
      title: "Sr. No.",
      //render: (text, record, index) => index + 1,
      render: (text, record, index) =>
        ((pagination?.current || 1) - 1) * (pagination?.pageSize || 100) +
        index +
        1,

      className: "all-nowrap-column",
    },
    {
      title: "Name",
      dataIndex: "empName",
      key: "empName",
      className: "all-nowrap-column",
    },
    {
      title: "Emp. Id.",
      dataIndex: "empID",
      className: "all-nowrap-column",
    },
    {
      title: "Nature of Expense",
      dataIndex: "natureOfExpense",
      className: "all-nowrap-column",
    },
    {
      title: "Vendor Name",
      dataIndex: "businessPurpose",
    },
    {
      title: "Project Code",
      dataIndex: "projectCodeID",
    },
    {
      title: "Expense Period",
      dataIndex: "expensePeriod",
      className: "all-nowrap-column",
    },
    {
      title: "Expense Month",
      dataIndex: "month",
    },
    {
      title: "Department Code",
      dataIndex: "departmentID",
    },
    {
      title: "Expense Code",
      dataIndex: "expenseCodeID",
    },
    {
      title: "Currency",
      dataIndex: "currencyID",
      className: "all-nowrap-column",
    },
    {
      title: "Amount",
      dataIndex: "cost",
      className: "all-nowrap-column",
    },
    {
      title: "Total Amount",
      dataIndex: "totalReimbursement",
      className: "all-nowrap-column",
    },
    ...additionalSAColumn,
    ...additionalAAColumn,
    {
      title: "Status",
      dataIndex: "status",
      className: "all-nowrap-column",
      render: (text) => (
        <span
          className={`table-btn cursor-unset text-capitalize ${text?.toLowerCase()}-btn`}
        >
          {text?.toLowerCase() ===
          process.env.REACT_APP_SEEK_ACK_STATUS.replace(" ", "")?.toLowerCase()
            ? process.env.REACT_APP_SEEK_ACK_STATUS
            : text?.toLowerCase() ===
              process.env.REACT_APP_ACK_REC_STATUS.replace(
                " ",
                ""
              )?.toLowerCase()
            ? process.env.REACT_APP_ACK_REC_STATUS
            : text?.toLowerCase() ===
              process.env.REACT_APP_NORESPONSE_STATUS.replace(
                " ",
                ""
              )?.toLowerCase()
            ? process.env.REACT_APP_NORESPONSE_STATUS
            : text?.toLowerCase()}
        </span>
      ),
    },
    {
      title: "Payment Paid On",
      dataIndex: "paymentPaidOn",
      className: "all-nowrap-column",
      key: "paymentPaidOn",
      render: (date, record) => {
        if (!moment(date).isValid()) return "-";

        return (
          <>
            {moment(date).format("Do MMM, YYYY")}
            {record?.modeOfPayment && (
              <>
                <br />(<strong>Mode of Payment: </strong>{" "}
                {record?.modeOfPayment})
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      // className: "all-nowrap-column",
      render: (text, record) => {
        const draft =
          searchIn === process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN &&
          record.status === process.env.REACT_APP_DRAFT_STATUS.toUpperCase() &&
          record.empID === storeEmpID
            ? 1
            : 0;
        const link =
          draft === 1
            ? `/${searchIn}/draft/${record?.key}`
            : `/${searchIn}/${record?.key}`;
        const viewTitle = draft === 1 ? "View Draft" : "View";
        return (
          <>
            <div className="whiteSpaceNowrap child-action">
              <Link to={`${link}`} target="_blank" title={`${viewTitle}`}>
                <i className="flaticon-eye icon-lg text-grey-custom mr-5"></i>
              </Link>
              {draft === 1 && (
                <Link
                  to={`${link}`}
                  state={{ publishDraftExpense: true }}
                  title="Publish"
                >
                  <i
                    className="fas fa-paper-plane icon-lg text-grey-custom mr-5"
                    aria-hidden="true"
                  ></i>
                </Link>
              )}
              <i
                className="fas fa-file-pdf icon-lg text-grey-custom cursor-pointer"
                onClick={() => handlePdfExport(record)}
                title="Download PDF"
              ></i>
            </div>
          </>
        );
      },
    },
  ];
  const [expenseDetail, setExpenseDetail] = useState(null);

  const generatePdfContent = (
    record,
    expenseDetail,
    storeRole,
    storeToken,
    storeAccessTokenExpiresOn
  ) => {
    return ReactDOMServer.renderToString(
      <ExportPdf
        record={record}
        expenseDetail={expenseDetail}
        storeRole={storeRole}
        storeToken={storeToken}
        storeAccessTokenExpiresOn={storeAccessTokenExpiresOn}
      />
    );
  };
  const handlePdfExport = async (record) => {
    try {
      // Fetch expense details
      const endpoint = `/list-of-expense/${record?.key}`;
      const method = "GET";
      const payload = {};
      const response = await APICaller(
        storeRole,
        storeToken,
        endpoint,
        method,
        payload,
        storeAccessTokenExpiresOn
      );

      setExpenseDetail(response);

      if (response) {
        // Step 1: Generate HTML content as a string
        const htmlContent = generatePdfContent(
          record,
          response,
          storeRole,
          storeToken,
          storeAccessTokenExpiresOn
        );

        // Define PDF options
        const options = {
          margin: [10, 10, 10, 10],
          filename: `${record.key}_Details.pdf`,
          html2canvas: {
            scale: 2, // Increase scale for better resolution
            useCORS: true,
            logging: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a4",
            orientation: "portrait",
          },
        };

        // Generate PDF
        html2pdf()
          .from(htmlContent)
          .set(options)
          .save()
          .catch((error) => {
            console.error("Error generating PDF:", error);
          });
      }
    } catch (error) {
      console.error("Error fetching data or generating PDF:", error);
    }
  };
  const filteredERList =
    storeERList &&
    Array.isArray(storeERList) &&
    storeERList.map(({ key, id, ...rest }) => rest);

  // Filter the storeList based on the searchText

  // let searchFilterData =
  //   refinedData &&
  //   Array.isArray(refinedData) &&
  //   refinedData.filter((item) => {
  //     const empID = item.empID ? item.empID : "";
  //     const empName = item.empName ? item.empName.toLowerCase() : "";
  //     const natureOfExpense = item.natureOfExpense
  //       ? item.natureOfExpense.toLowerCase()
  //       : "";
  //     const businessPurpose = item.businessPurpose
  //       ? item.businessPurpose.toLowerCase()
  //       : "";
  //     const tamount = item.totalReimbursement ? item.totalReimbursement : "";
  //     const status = item?.status ? item.status.toLowerCase() : "";

  //     return (
  //       empID === Number(searchText) ||
  //       empName.includes(searchText.toLowerCase()) ||
  //       natureOfExpense.includes(searchText.toLowerCase()) ||
  //       businessPurpose.includes(searchText.toLowerCase()) ||
  //       tamount === Number(searchText) ||
  //       status.includes(searchText.toLowerCase())
  //     );
  //   });

  const handlePaginationChange = (page, pageSize) => {
    setPagination({
      current: page,
      page,
      pageSize,
    });

    if (pageSize === storeTotalCount) {
      if (!searchText) {
        // Load all items
        getPendingRequestsList("pagination", {
          page: 1,
          pageSize: Number(storeTotalCount),
        });
      } else {
        handleGlSearch(searchText, page, pageSize, "pagination");
      }
    } else {
      if (!searchText) {
        // Regular pagination
        getPendingRequestsList("pagination", { page, pageSize });
      } else {
        handleGlSearch(searchText, page, pageSize, "pagination");
      }
    }
  };

  const handleGlSearch = async (
    searchKeyword,
    page = 1,
    pageSize = recordLimit,
    source = ""
  ) => {
    source !== "pagination" && setPagination(initialPagState);

    setSearchText(searchKeyword);
    setShowLoader(true);

    // Prepare the date range
    let startRange = "";
    let endRange = "";

    const startMonthInput = document.querySelector('input[date-range="start"]');
    const endMonthInput = document.querySelector('input[date-range="end"]');

    if (startMonthInput?.value) {
      startRange = `${new Date(startMonthInput.value).getFullYear()}-${String(
        new Date(startMonthInput.value).getMonth() + 1
      ).padStart(2, "0")}`;
    }

    if (endMonthInput?.value) {
      endRange = `${new Date(endMonthInput.value).getFullYear()}-${String(
        new Date(endMonthInput.value).getMonth() + 1
      ).padStart(2, "0")}`;
    }

    const payload = {
      searchIn,
      searchKeyword,
      //fetchWithoutPagination: "yes",
      role: storeRole,
      month: startRange && endRange ? { startRange, endRange } : "",
      status,
      lIUId: storeLIUId,
      page,
      pageSize: Number(pageSize),
    };

    try {
      const response = await APICaller(
        storeRole,
        storeToken,
        "/search",
        "POST",
        payload,
        storeAccessTokenExpiresOn
      );

      if (Array.isArray(response?.response)) {
        const filteredfiltered = response.response.map((records) => {
          return {
            key: records?.key,
            empName: records?.empName,
            empID: records?.empID,
            businessPurpose: records?.businessPurpose,
            natureOfExpense: records?.natureOfExpense || "-",
            projectCodeID: records?.projectCodeID?.code
              ? `${records.projectCodeID?.code}-${records.projectCodeID?.companyName}`
              : "N/A",
            departmentID:
              records?.expensesDetails && records?.expensesDetails.length === 1
                ? records.expensesDetails[records.expensesDetails.length - 1]
                    ?.departmentID || null
                : "-",
            // records?.expensesDetails && records?.expensesDetails.length === 1
            //   ? records.expensesDetails[records.expensesDetails.length - 1]
            //       ?.departmentID?.name +
            //       " - " +
            //       records.expensesDetails[records.expensesDetails.length - 1]
            //         ?.departmentID?.code || null
            //   : "-",
            expenseCodeID:
              records?.expensesDetails && records?.expensesDetails.length === 1
                ? records.expensesDetails[records.expensesDetails.length - 1]
                    ?.expenseCodeID || null
                : "-",
            // records?.expensesDetails && records?.expensesDetails.length === 1
            //   ? records.expensesDetails[records.expensesDetails.length - 1]
            //       ?.expenseCodeID?.costCode +
            //       " - " +
            //       records.expensesDetails[records.expensesDetails.length - 1]
            //         ?.expenseCodeID?.name || null
            //   : "-",
            currencyID:
              records?.expensesDetails && records?.expensesDetails.length === 1
                ? records.expensesDetails[records.expensesDetails.length - 1]
                    ?.currencyID || null
                : "-",
            // records?.expensesDetails && records?.expensesDetails.length === 1
            //   ? records.expensesDetails[records.expensesDetails.length - 1]
            //       ?.currencyID?.code || null
            //   : "-",
            cost:
              records?.expensesDetails && records?.expensesDetails.length === 1
                ? records.expensesDetails[records.expensesDetails.length - 1]
                    ?.cost || null
                : "-",
            totalReimbursement: records?.totalReimbursement,
            approvers: records?.approvers,
            adminApprover:
              records.status ===
                process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
              records?.adminApprover?.[0]?.status ===
                process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
              records?.adminApprover?.[0]?.reason
                ? process.env.REACT_APP_SENTBACK_STATUS
                : records?.adminApprover?.[0]?.status ===
                  process.env.REACT_APP_APPROVED_STATUS.toUpperCase()
                ? process.env.REACT_APP_APPROVED_STATUS
                : records?.adminApprover?.[0]?.status ===
                    process.env.REACT_APP_CANCELED_STATUS.toUpperCase() &&
                  records?.adminApprover?.[0]?.reason
                ? process.env.REACT_APP_CANCELED_STATUS
                : process.env.REACT_APP_PENDING_STATUS,
            expensePeriod:
              records?.expensePeriodFromDate && records?.expensePeriodToDate
                ? moment(records.expensePeriodFromDate).format("Do MMM, YYYY") +
                  " - " +
                  moment(records.expensePeriodToDate).format("Do MMM, YYYY")
                : "",
            month: records?.expensePeriodFromDate
              ? moment(records.expensePeriodFromDate).format("MMM")
              : "",
            expensePeriodFromDate: records?.expensePeriodFromDate
              ? moment(records.expensePeriodFromDate).format("DD-MM-YY")
              : "",
            onBehalfApprovers: records?.onBehalfApprovers || null,
            children:
              records?.children && records?.children.length > 1
                ? records.children || null
                : null,
            paymentPaidOn: records?.paymentPaidOn || null,
            modeOfPayment: records?.modeOfPayment || null,
            /*paymentPaidOn: records?.paymentPaidOn ? (
              <>
                {moment(records?.paymentPaidOn).format("Do MMM, YYYY")}
                {records?.modeOfPayment && (
                  <>
                    <br />(<strong>Mode of Payment: </strong>{" "}
                    {records?.modeOfPayment})
                  </>
                )}
              </>
            ) : (
              "-"
            ),*/
            status: records?.history?.[records.history.length - 1]?.status,
          };
        });
        currentPath !== "dashboard" && setSearchFilterData(filteredfiltered);
        setStoreTotalCount(response?.totalCount);
        setShowLoader(false);
      }
    } catch (err) {
      console.error("Search API failed", err);
    }
  };

  const handleDraftExpenseForPublish = () => {
    setShowLoader(true);
    const endpoint = `/publishMulExpense`;
    const method = "PUT";
    const payload = {
      action: "publishMul",
      ids: selectedRowKeys,
      historySource: "listing-page-publish-button",
      historyUserID: storeLIUId,
      historyAction: "Publishing drafted expense",
      status: process.env.REACT_APP_PENDING_STATUS.toUpperCase(),
    };

    const messageKey = "publishDraftExpenseError";

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        setShowLoader(false);
        if (response.statusCode) {
          if (response.message) {
            message.open({
              key: messageKey,
              type: response.statusCode === 400 ? "error" : "success",
              duration: 0, // stay until closed
              content: (
                <div className="customMsgPopup">
                  <span>{response.message}</span>
                  <Button
                    type="link"
                    size="small"
                    onClick={() => message.destroy(messageKey)}
                  >
                    X
                  </Button>
                </div>
              ),
            });
          } else {
            setHasSelectedRows("");
            message.destroy("publishDraftExpenseError");
            message.success("Expense published successfully.");
          }
          getPendingRequestsList();
        }
      })
      .catch((error) => {
        setShowLoader(false);
        message.error("Something went wrong!");
      });
  };

  return (
    <>
      {/* <ProcessingCustomLoader showLoader={showLoader} /> */}
      {name === "dashboardPendingRequest" ? (
        <>
          {filteredERList && filteredERList.length > 0 ? (
            filteredERList.map((item, index) => (
              <div className="d-flex align-items-center mb-5" key={index}>
                <div className="symbol symbol-30 symbol-circle mr-5">
                  <img
                    src={
                      item?.profilePicUrl
                        ? process.env.REACT_APP_BACKEND +
                          "/images/" +
                          item?.profilePicUrl
                        : media.user
                    }
                    alt="img"
                  />
                </div>
                <div className="d-flex flex-column flex-grow-1 font-weight-bold">
                  <span className="font-size-lg mb-1 text-dark-75">
                    {item?.empName}
                  </span>
                  <span className="text-dark-grey-custom font-size-md">
                    {item?.departmentID}
                  </span>
                </div>
                <div className="ml-2 text-dark-custom font-size-md font-weight-boldest">
                  {item?.totalReimbursement}
                </div>
              </div>
            ))
          ) : (
            <center>No data found</center>
          )}
        </>
      ) : (
        <>
          {currentPath !== "dashboard" && (
            <div
              className={`search-container ${
                hasSelectedRows != "" ? "hasSelectedRows" : ""
              }`}
            >
              {hasSelectedRows != "" && (
                <button
                  className="border border-light-dark btn font-weight-bolder px-4 py-2 text-dark-custom bg-transparent export-excel-button download-button"
                  onClick={() => {
                    handleDraftExpenseForPublish();
                  }}
                >
                  Publish
                </button>
              )}
              <Search
                allowClear
                className="table-search dashboardSearch"
                placeholder="Search Name, Nature of Expense, EmpID, Vendor Name & Total Amount.."
                //onSearch={handleGlSearch}
                onSearch={(value) => handleGlSearch(value)}
                // onSearch={(value) => setSearchText(value)}
                // onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          )}
          <Table
            rowSelection={
              String(status) ===
              process.env.REACT_APP_DRAFT_STATUS.toUpperCase()
                ? {
                    type: selectionType,
                    ...rowSelection,
                    getCheckboxProps: (record) => {
                      const parents = searchFilterData
                        ? searchFilterData
                        : refinedData;

                      let isChild = false;

                      // Look for this record in any parent's `children` array:
                      parents.forEach((parent) => {
                        if (Array.isArray(parent.children)) {
                          parent.children.forEach((child) => {
                            if (child.key === record.key) {
                              isChild = true;
                            }
                          });
                        }
                      });

                      return {
                        disabled: isChild,
                      };
                    },
                  }
                : undefined
            }
            columns={columns}
            bordered
            dataSource={searchFilterData ? searchFilterData : refinedData}
            className="expenseMultitasking"
            loading={showLoader}
            pagination={
              currentPath === "dashboard"
                ? false
                : {
                    current: (pagination && pagination?.current) || 1,
                    pageSize: (pagination && pagination?.pageSize) || 70,
                    total: storeTotalCount
                      ? storeTotalCount
                      : initialStoreTotalCount
                      ? initialStoreTotalCount
                      : 70,
                    pageSizeOptions: paginationOptions(
                      storeTotalCount
                        ? storeTotalCount
                        : initialStoreTotalCount
                        ? initialStoreTotalCount
                        : 70
                    ),
                    showSizeChanger: true,
                    onChange: (page, pageSize) =>
                      handlePaginationChange(page, pageSize),

                    onShowSizeChange: (current, size) =>
                      handlePaginationChange(current, size),
                    showTotal: (total, range) =>
                      `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                  }
            }
          />
        </>
      )}
    </>
  );
}
